import { invariant } from "tpm-utils";
import $ from "jquery";
import Widget from "./base.js";
import sortBy from "lodash/sortBy";
import isElement from "lodash/isElement";
import { setCookie, getCookie } from "tpm-utils";

/*
  accepts 'sm', 'md', 'lg', 'xl' as args

  at widths larger than or equal to min, show the ad
  at widths smaller than max, show the ad

  might wanna spin this off it's its own file for importing elsewhere? depends on what template needs
 */
function shouldRenderAd(min = null, max = null) {
	const breaks = {
		xl: 1200,
		lg: 1024,
		md: 768,
		sm: 576,
	};
	let overMin = true;
	let underMax = true;
	if (min) overMin = window.innerWidth > breaks[min];
	if (max) underMax = window.innerWidth <= breaks[max];
	return overMin && underMax;
}

export class StickyAdRail extends Widget {
	static get __json_props() {
		return ["slots", "bounds"];
	}

	get contentEl() {
		let el = $(this.props.contentEl);

		invariant(
			isElement(el[0]),
			"no contentEl for StickyAdRail %s",
			this.props.contentEl
		);

		return el;
	}

	get contentHeight() {
		try {
			return this.contentEl.height();
		} catch (err) {
			console.error(err);
			return 1400;
		}
	}

	componentWillMount() {}

	componentDidMount() {
		this.setState({
			contentHeight: this.contentHeight,
		});
		if (!this.props.isLiveBlog) return;
		/**
		 *live blog ajax's in the content, so we have to check the height periodically to make sure were loading enough ads
		 *there's probably a better way to handle this with some kind of controller scoped to the window but w/e
		 */
		setInterval(() => {
			let newHeight = this.contentHeight;
			// max height 5000
			if (newHeight > 5000) newHeight = 5000;
			if (newHeight > this.state.contentHeight) {
				this.setState({
					contentHeight: newHeight,
				});
			}
		}, 5000);
	}

	renderContent() {
		/* If the width props dont match, dont render this ad */
		const minWidth = this.props.hasOwnProperty("minWidth")
			? this.props.minWidth
			: null;
		const maxWidth = this.props.hasOwnProperty("maxWidth")
			? this.props.maxWidth
			: null;
		if (!shouldRenderAd(minWidth, maxWidth)) {
			this.placeholderSpan = true;
			return;
		}

		if (!this.state.contentHeight) return;

		let children = [];
		const bounds = sortBy(this.props.bounds || [0]);

		this.props.slots.forEach((slot, idx) => {
			if (bounds[idx] <= this.state.contentHeight + 900) {
				if (idx === 2 && this.props.civicSciencePoll) {
					children.push(
						<div class="AdSlot --civic-science">
							<div
								id="civsci-id-163878918"
								data-civicscience-widget="e2d539fc-6b4b-c614-c141-64581a83c000"
								style="position: initial;"
							/>
							<script
								type="text/javascript"
								async
								src="https://www.civicscience.com/jspoll/4/civicscience-widget.js"
							/>
						</div>
					);
				} else {
					children.push(<AdSlot unit={slot} minWidth="md" />);
				}
			}
		});

		return (
			<div
				class={`StickyAdRail__Inner ${
					this.props.isLiveBlog ? "--live-blog" : ""
				}`}
				style={{ height: `${this.state.contentHeight}px` }}
			>
				{children}
			</div>
		);
	}
}

export class AdSlot extends Widget {
	setUpAd() {
		const slotEl = document.createElement("div");

		slotEl.className = `htlad-${this.props.unit}`;

		if (typeof htlbid === "undefined") return;

		if (!this.props.nohtlbid) {
			htlbid.cmd.push(() => {
				this._domNode.appendChild(slotEl);
				this.setState({ slotEl });
			});
		}
	}

	get isWideDesktopWidth() {
		return window.innerWidth >= 1281;
	}

	get isDesktopWidth() {
		return window.innerWidth >= 1020 && window.innerWidth < 1281;
	}

	get isTabletWidth() {
		return window.innerWidth >= 782 && window.innerWidth < 1020;
	}

	get isMobileWidth() {
		return window.innerWidth < 782;
	}

	componentDidMount() {
		if (this.noAds()) return;

		//make the fp device exclusions work
		if (this.props.excludeDesktop && this.isDesktopWidth) return;
		if (this.props.excludeTablet && this.isTabletWidth) return;
		if (this.props.excludeMobile && this.isMobileWidth) return;
		//make the fp prime member exclusion work
		if (this.props.excludePrime && window.is_prime && !window.is_adfree) return;

		this.setUpAd();
	}

	noAds() {
		//no ads on pages with these paths
		if (
			window.location.pathname.indexOf("/prime") > -1 ||
			window.location.pathname.indexOf("/users") > -1 ||
			window.location.pathname.indexOf("/account") > -1 ||
			window.location.pathname.indexOf("/memberships") > -1 ||
			window.location.pathname.indexOf("/signin") > -1
		) {
			return true;
		}

		/* If the width settings dont match, dont render this ad */
		const minWidth = this.props.hasOwnProperty("minWidth")
			? this.props.minWidth
			: null;
		const maxWidth = this.props.hasOwnProperty("maxWidth")
			? this.props.maxWidth
			: null;
		return !shouldRenderAd(minWidth, maxWidth);
	}

	getSlotContainer() {
		return $(this._domNode).find(`#${this.state.slotElementId}`)[0];
	}

	shouldComponentUpdate() {
		return false;
	}

	renderContent() {
		if (this.noAds()) return;

		const html = `
      <div id="breakout-${this.props.unit}"></div>
    `;
		return (
			<div
				class="da-wrapper"
				ref={(x) => (this._domNode = x)}
				dangerouslySetInnerHTML={{ __html: html }}
			/>
		);
	}
}
